import React, { useState, useEffect } from 'react';
import ELK from 'elkjs/lib/elk.bundled';

import { ArrowRightMarker } from '@carbon/charts-react/diagrams/Marker';

import Edge from './Edge';
import Node from './Node';

export default function Graph({
  direction = 'RIGHT',
  id,
  nodes,
  edges
}) {
  const elk = new ELK({
    defaultLayoutOptions: {
      'elk.algorithm': 'layered',
      'elk.direction': direction,
      'elk.edgeRouting': 'ORTHOGONAL',
      'elk.layered.mergeEdges': true, // avoid multiple input ports / output ports per node
      // TODO: test
      // 'elk.layered.nodePlacement.bk.fixedAlignment': 'BALANCED',
      // 'elk.layered.nodePlacement.strategy': 'BRANDES_KOEPF',
      // 'elk.layered.nodePlacement.strategy': 'NETWORK_SIMPLEX',
      // 'crossingMinimization.semiInteractive': true,
      // 'elk.layered.spacing.edgeNodeBetweenLayers': '50',
      // 'elk.layered.unnecessaryBendpoints': true,
      // 'org.eclipse.elk.layered.layering.strategy': 'INTERACTIVE',
      // 'elk.padding': '[left=50, top=50, right=50, bottom=50]',
      // portConstraints: 'FIXED_ORDER', // this gives correct node order but ignores mergeEdges and has other issues
      // 'elk.layered.considerModelOrder.strategy': 'NODES_AND_EDGES',
      // 'elk.layered.considerModelOrder.crossingCounterNodeInfluence': 0.001,
      // 'elk.layered.considerModelOrder.crossingCounterPortInfluence': 0.001,
      separateConnectedComponents: false,
      'spacing.nodeNode': 20,
      'spacing.nodeNodeBetweenLayers': 50
    }
  });

  const [positions, setPositions] = useState(null);

  const graph = {
    id,
    children: nodes,
    edges
  };

  useEffect(() => {
    elk
      .layout(graph)
      .then((g) => setPositions(g))
      .catch(console.error);
  }, [direction]);

  if (!positions) return null;

  const {
    children: graphNodes,
    edges: graphEdges,
    height: graphHeight,
    width: graphWidth
  } = positions;

  return (
    <div className="tkn--pipeline-graph">
      <svg style={{ height: graphHeight, width: graphWidth }}>
        <defs>
          <ArrowRightMarker id="arrowRight" />
        </defs>
        {
          graphEdges.map((edge, i) => {
          return <Edge direction={direction} key={`edge_${i}`} edge={edge} />;
          })
        }
        {
          graphNodes.map((node, i) => {
            return (
              <Node
                key={`node_${i}`}
                node={node}
              />
            );
          })
        }
      </svg>
    </div>
  );
}